import delegate from 'delegate'

// Use child link on parent click

export default function () {
  delegate('[data-sublink]', 'click', e => {
    const a = e.delegateTarget.querySelector('a')
    if (a && e.target !== a) {
      a.click()
      return
    }
    const btn = e.delegateTarget.querySelector('button')
    if (btn && e.target !== btn) {
      btn.click()
      return
    }
  }, false)
}